<template>
  <div class="flex-rules-root">
    <div class="header">
      <div class="cell x-small">
        <span v-text="$t('date')"></span>
      </div>
      <div class="cell small">
        <span v-text="$t('dish_type')"></span>
      </div>
      <div class="cell">
        <span v-text="$t('flexible_rule')"></span>
      </div>
    </div>

    <div class="content">
      <div
        v-for="(row, index) in processedFlexRules"
        :key="index"
        class="row"
      >
        <div class="cell x-small center" :title="row.date">{{ row.date }}</div>
        <div class="cell small center" :title="row.dish">{{ row.dish }}</div>
        <div class="cell center" :title="row.rule">{{ row.rule }}</div>
      </div>

      <div v-if="processedFlexRules.length === 0" class="empty-state">
        {{ $t('there_is_no_scenario_generated') }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FlexibleRulesComponent",
  props: ["cardData"],
  computed: {
    processedFlexRules() {
      const catalog = this.cardData?.dataCatalog;

      if (!catalog || !Array.isArray(catalog.ignoredRules)) {
        return [];
      }

      const result = [];
      const seen = new Set();

      for (const r of catalog.ignoredRules) {
        const date = r.data;
        const dish = catalog?.colunas?.[r?.id_coluna]?.nm_tipoprato;

        if (!dish) continue;

        const rule = this.$t(r.rule);

        const key = `${date}_${dish}_${rule}`;
        if (seen.has(key)) continue;
        seen.add(key);

        result.push({ date, dish, rule });
      }

      return result;
    }
  },
};
</script>

<style scoped lang="less">
@import (reference) url("../../assets/variables.less");

.flex-rules-root {
  position: relative;
}

.header {
  display: flex;
  background: linear-gradient(160deg, #24244f 0%, #1e2c6c 100%);
  color: white;
  padding: 9px 10px;
  border-radius: 10px;
  text-transform: uppercase;
  margin-bottom: 8px;
  box-shadow: 0 3px 10px rgba(19, 24, 41, 0.18);

  .cell span {
    font-size: 0.7rem;
    font-weight: 700;
    letter-spacing: 0.02em;
  }
}

.content {
  display: flex;
  flex-direction: column;
  max-height: 26em;
  overflow-y: auto;
  border: 1px solid rgba(33, 33, 70, 0.1);
  border-radius: 10px;
  background: #fff;

  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(70, 83, 124, 0.45);
    border-radius: 999px;
  }
}

.row {
  display: flex;
  justify-content: space-around;
  min-height: 36px;
  border-bottom: 1px solid rgba(33, 33, 70, 0.08);
  transition: background-color 0.14s ease;

  &:hover {
    background: rgba(220, 232, 252, 0.55);
  }
}

.row:nth-child(even) {
  background-color: #fff;
}

.row:nth-child(odd) {
  background-color: rgba(242, 245, 252, 0.9);
}

.cell {
  flex: 1;
  display: flex;
  align-items: center;
  min-width: 0;
}

.small {
  flex: 0.35;
}

.x-small {
  flex: 0.2;
}

.center {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #1f2747;
  font-size: 0.84rem;
  font-weight: 600;
  line-height: 1.25;
  padding: 7px 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.empty-state {
  padding: 14px 10px;
  text-align: center;
  color: #4d5a86;
  font-size: 0.85rem;
  font-weight: 600;
}
</style>
